import React from "react";
import DataTable from "../../components/DataTable";
import { ChartValue, MtmItem, PortfolioEntry, TrendInfo } from "types";

import styles from "./styles.module.scss";
import { Grid, Header } from "semantic-ui-react";
import { MTM_COLUMNS } from "common/constants";
import Spinner from "components/Spinner";
import { RootState } from "StoreTypes";
import {
  fetchMTMReportLoading,
  fetchMtmReport,
  fetchMTMReportError,
} from "../../services/reports/selectors";
import { connect } from "react-redux";
import Charts from "../../components/CurrencyChart";
import { displaySliceId } from "../../utils/sliceFormat";
import { mapToChartValues } from "../../utils/chartFormat";

export interface Props {
  mtmReport: MtmItem;
  loading: boolean;
}

const MTMReportViewer = ({ mtmReport, loading }: Props) => {
  let isReportPopulated = false;

  if (Object.keys(mtmReport).length > 0) {
    isReportPopulated = true;
  }

  const negativeTableData = isReportPopulated
    ? mtmReport.portfolioDiff.filter((positive) =>
        positive.reqChg.includes("-")
      )
    : [];

  const positiveTableData = isReportPopulated
    ? mtmReport.portfolioDiff.filter(
        (positive) => !positive.reqChg.includes("-")
      )
    : [];

  const sliceID = mtmReport.curSlice ? mtmReport.curSlice.id : "";

  return (
    <div className={styles.container}>
      <h1 className="cf-header">
        MTM Detail - {mtmReport.curSlice ? mtmReport.curSlice.date : ""}
        {" - "}
        {displaySliceId(sliceID)}
      </h1>
      <Spinner loading={loading}>
        <div className={styles.chart} id="chart-mtm">
          {mtmReport.trend && (
            <Charts
              data={mapToChartValues(mtmReport.trend?.totalRequirement.values)}
            />
          )}
        </div>
        {mtmReport && isReportPopulated && (
          <div>
            <div className={styles.tables}>
              <Grid columns={2} padded>
                <Grid.Column>
                  <Header as="h3" dividing>
                    Losses <i className="fa fa-angle-double-down"></i>
                  </Header>
                  <div id={"mtm-losses"}>
                    <DataTable
                      tableData={negativeTableData}
                      columns={MTM_COLUMNS}
                      csvFileName="mtm-report.csv"
                    />
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <Header as="h3" dividing>
                    Gains <i className="fa fa-angle-double-up"></i>
                  </Header>
                  <div id={"mtm-gains"}>
                    <DataTable
                      tableData={positiveTableData}
                      columns={MTM_COLUMNS}
                      csvFileName="mtm-report.csv"
                    />
                  </div>
                </Grid.Column>
              </Grid>
            </div>
          </div>
        )}
      </Spinner>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  loading: fetchMTMReportLoading(state),
  mtmReport: fetchMtmReport(state),
  error: fetchMTMReportError(state),
});

export default connect(mapStateToProps)(MTMReportViewer);
